import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=d1755cd2&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=d1755cd2&prod&lang=css"
import style1 from "./indexNew.vue?vue&type=style&index=1&id=d1755cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1755cd2",
  null
  
)

export default component.exports